import { render, staticRenderFns } from "./BlogComment.vue?vue&type=template&id=775f8efb&"
import script from "./BlogComment.vue?vue&type=script&lang=js&"
export * from "./BlogComment.vue?vue&type=script&lang=js&"
import style0 from "./BlogComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports